import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["form"]
    static values = {
        url: String,
        frame: String
    }

    render() {
        const url = new URL(this.urlValue);
        const formData = new FormData(this.formTarget);
        for (const pair of formData.entries()) {
            if (pair[0] !== "_method" && pair[0] !== "authenticity_token") {
                url.searchParams.append(pair[0], String(pair[1]));
            }
        }
        Turbo.visit(url, {frame: this.frameValue});
    }

}
